module.exports = __webpack_public_path__ + "img/chat.8f44e321.svg";